import { Button, ButtonProps } from "../../core/components/button";
import { DropDownList } from "../../core/components/dropDownList";
import { FieldInstance } from "../../core/components/field";
import GridLayout, { BreakPoint, GridLayoutBreakPointConfig } from "../../core/components/gridLayout";
import { Region } from "../../core/components/region";
import { Config } from "../../core/config/config";
import { ComponentHelper } from "../../core/util/componentHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { InternalCurrency, OpenInternalCurrencyDialog, OpenMainGroupInternalCurrencyDialog } from "./dialogs/internalCurrencyDialog";
import MainGroupCurrenciesGrid from "./mainGroupCurrenciesGrid";
import MainGroupInternalCurrenciesGrid from "./mainGroupInternalCurrenciesGrid";
import React from "react";
interface MainGroupCurrencyProps {
    context: ContextGeneralSettingsApp;
}

export default class MainGroupCurrencies extends React.Component<MainGroupCurrencyProps, {
    idCurr: number;
    currencyDropDownDataSource: any[];
}>{
    private _factory = ComponentHelper.createFactory();
    private getLayoutConfig = (): GridLayoutBreakPointConfig[] => {
        return [
            {
                breakPoint: BreakPoint.ExtraLarge,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Large,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Medium,
                size: "6/12"
            },
            {
                breakPoint: BreakPoint.Small,
                size: "12/12"
            },
            {
                breakPoint: BreakPoint.ExtraSmall,
                size: "12/12"
            }
        ]
    }

    constructor(props) {
        super(props);
        this.state = {
            idCurr: null,
            currencyDropDownDataSource: null
        }
    }

    componentDidMount() {
        this.loadCurrencyDropDownDataSource();
    }

    private loadCurrencyDropDownDataSource = async () => {
        let result = await HTTPService.get<any[]>("GeneralSettingsCurrency/GetCurrencyList");
        this.setState({ currencyDropDownDataSource: result });
    }

    private createDropDown = () => {
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.idCurr ?? 0;
        props.field.refreshDSOnRefChange = true;
        props.field.dataTextField = "Bezeichnung";
        props.field.dataValueField = "Id";
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:290px'><colgroup><col style='width: 60px' /><col style='width: 60px' /><col style='width: 200px' /><col style='width: 30px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Id}</td><td style='vertical-align:top'>${data.Currency}</td><td style='vertical-align:top'>${data.Bezeichnung}</td><td style='vertical-align:top'>${data.Zeichen}</td></tr></table>";
        props.dataSource = this.state.currencyDropDownDataSource;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ idCurr: value });
        }
        props.onDataLoaded = () => {
        }
        return (
            <FieldInstance label={Helper.getTranslation("Standard.Schema")} noHover={true} labelStyle={{ width: "auto" }}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private onCreateNewId = async () => {
        let currency = await OpenMainGroupInternalCurrencyDialog(null);
        this.createNewId(currency);
    }

    private deleteId = async () => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/DeleteMainGroupDependentCurrencies?idCurr=" + this.state.idCurr);
        if (result.Code == 0) {
            this.setState({ idCurr: null }, () => this.loadCurrencyDropDownDataSource());
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private createNewId = async (currency: InternalCurrency) => {
        let result = await HTTPService.post<JsonResultClass<number>>("GeneralSettingsCurrency/CreateNewCurrencyId", currency);
        if (result.Code == 0) {
            this.setState({ idCurr: result.Data }, () => this.loadCurrencyDropDownDataSource());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private createButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.onCreateNewId();
            },
            iconName: "plus",
            title: Config.translations.newLabel,
            buttonStyle: {
                marginLeft: "5px",
                marginTop: "5px"
            }
        }
        return <Button {...props} />
    }

    private deleteButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.deleteId();
            },
            iconName: "trash",
            title: Config.translations.deleteLabel,
            buttonStyle: {
                marginLeft: "5px",
                marginTop: "5px"
            },
            readOnly: this.state.idCurr == null || this.state.idCurr == 0
        }
        return <Button {...props} />
    }

    private createMainGroupInternalCurrenciesGrid() {
        return <Region title={Helper.getTranslation("WebSMS.GeneralSettings.Currency.InternalCurrency")} >
            <MainGroupInternalCurrenciesGrid idCurr={this.state.idCurr} gridOptions={this.props.context.internalCurrencyGridOptions} />
        </Region>
    }

    private createMainGroupCurrenciesGrid() {
        return <Region title={Helper.getTranslation("WebSMS.GeneralSettings.Currency.Currency")} >
            <MainGroupCurrenciesGrid idCurr={this.state.idCurr} gridOptions={this.props.context.currencyGridOptions} />
        </Region>
    }

    render() {
        let dropDown = this.createDropDown();
        let buttonNew = this.createButton();
        let buttonDelete = this.deleteButton();

        let renderGrids = Helper.hasValue(this.state.idCurr) && this.state.idCurr > 0;
        let internalCurrGrid = renderGrids ? this.createMainGroupInternalCurrenciesGrid() : null;
        let currGrid = renderGrids ? this.createMainGroupCurrenciesGrid() : null;

        return (<>
            <div style={{ display: "flex", flexDirection: "row", width: "auto" }}>
                {dropDown}
                {buttonNew}
                {buttonDelete}
            </div>
            <GridLayout config={[this.getLayoutConfig(), this.getLayoutConfig()]}>
                {currGrid}
                {internalCurrGrid}
            </GridLayout>
        </>)
    }
}